<div
  data-cy="won_message"
  class="component-container"
  [style.backgroundColor]="config().backgroundColor"
>
  <img
    class="amount-container"
    [src]="config().amount.imageUrl"
    [alt]="config().amount.alternativeText | replaceVars: amount()"
  />
  @let tmpAmount = amount() | formatAmount: 'currency';
  <div
    class="amount"
    [style]="{
      color: config().amount.color,
      fontFamily: config().amount.fontFamily,
    }"
    [innerHTML]="config().amount.template | replaceVars: tmpAmount | safe"
  ></div>
  <p
    class="complementary-msg"
    [style]="{
      color: config().complementaryMsg.color,
      fontFamily: config().complementaryMsg.fontFamily,
    }"
  >
    {{ config().complementaryMsg.text }}

    <img
      [alt]="config().complementaryMsg.backgroundImage.alternativeText"
      [src]="config().complementaryMsg.backgroundImage.imageUrl"
    />
  </p>
</div>
